<div class="flex flex-col gap-5">
  @for (field of fields(); track field.title) {
    <article>
      @if (edit() && field.edit) {
        <app-input
          [data]="field"
          [edit]="true"
          [independent]="false"
          [translateValue]="!!field.edit.translateValue"
          [hasErrors]="invalidFields().includes(field.edit.valueToChange)"
          [error]="literalService.get('errors.requiredField', true)"
          (changeEventEmitter)="onChange($event, field)"
          (setEventEmitter)="onSet($event, field)"
          (searchEventEmitter)="onSearch($event, field)"
        />
      } @else {
        <app-detail [data]="field" [value]="field.value" />
      }
    </article>
  }
</div>
